import { useQuery } from 'react-query';
import { useEffect } from 'react';

import { getMiceActivityDonutChartData } from 'api/analitics/MCTCharts/3_getMiceActivityDonutChart';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export const useGetMiceActivityDonutChartData = (
  slug: string,
  trapType: TrapType,
  start_date: string,
  end_date: string,
  enabled?: boolean,
) => {
  const { data, refetch, isLoading, isFetching } = useQuery(
    ['tMiceActivityDonutChartDat', slug, start_date, end_date],
    () => getMiceActivityDonutChartData(slug, trapType, start_date, end_date),
    {
      refetchOnWindowFocus: false,
      enabled,
    },
  );

  useEffect(() => {
    refetch();
  }, [slug, trapType, refetch]);

  return { data, refetch, isLoading, isFetching };
};

export default useGetMiceActivityDonutChartData;
